// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { appState, appReducer } from 'store/behaviors/loader';
import capabilities from './capabilities';

const slice = createSlice({
    name: 'commandExecution',
    initialState: {
        ...appState(capabilities)
    },
    reducers: {
        ...appReducer(capabilities)
    }
});

export default slice.reducer;

export const commandExecutionActions = slice.actions;
